import Http from '../../../../network/Http';
import {AuthoritySettings} from '../../residentUser/repository/NatGetResidentUserInvolvingSub';
import {NatBaseResponseInterface} from '../../common/repository/NatBaseResponseInterface';

export interface UpdateSubUserAuthoritySettingRequest {
    authoritySettings:AuthoritySettings[]
}

export interface UpdateSubUserAuthoritySetting extends NatBaseResponseInterface {
    details: null
}

export default class NatAuthorityRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    // サブユーザ権限更新
    async updateSubUserAuthoritySetting(params: {
        condominiumCd: string,
        ridgeCd: string,
        roomNumber: string,
        seq: number,
        requestParam: UpdateSubUserAuthoritySettingRequest
    }): Promise<UpdateSubUserAuthoritySetting> {
        return await this.http.put(
            `/api/resident/condominiums/${params.condominiumCd}/ridges/${params.ridgeCd}/rooms/${params.roomNumber}/subuser/${params.seq}/authorities`,
            params.requestParam
        )
    }
}